import { render, staticRenderFns } from "./WorkAside.vue?vue&type=template&id=0368935d&"
import script from "./WorkAside.vue?vue&type=script&lang=js&"
export * from "./WorkAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports